import { client } from '@frontend/features/common/services';
import { SaleOrderResponseDto, CreateSaleOrderDto } from '@bandido/shared/dtos';
import { SERVICE_REQUEST_TIMEOUTS } from '@bandido/shared/constants';

export const fetchSaleOrder = async (): Promise<SaleOrderResponseDto> => {
  const { data } = await client.get('/sale-orders');
  return data;
};

export const addSaleOrderItem = async (payload: CreateSaleOrderDto & { socketId: string }): Promise<SaleOrderResponseDto> => {
  const { socketId, ...params } = payload;
  const { data } = await client.post(
    '/sale-orders',
    params,
    {
      headers: {
        'socket-id': payload.socketId,
      },
    }
  );
  return data;
};

export const removeItemFromSaleOrder = async (itemId: string) => await client.delete(`/sale-orders/item/${itemId}`);

export const convertCartToSaleOrder = async (id: string): Promise<SaleOrderResponseDto> => {
  const { data } = await client.post(`/sale-orders/convert/${id}`, {
    timeout: SERVICE_REQUEST_TIMEOUTS.quotation,
  });
  return data;
};
